var oAuth = {};

// initialize oAuth global variables
oAuth.clientId = null;
oAuth.redirect = null;
oAuth.icon = null;
oAuth.state = null;

export default oAuth;